import PropTypes from 'prop-types';
import classNames from 'classnames';

import { trans } from '@spotahome/soyuz/client';
import { Button, Tag, useModalHandle } from '@spotahome/ui-library';
import { DSIcon } from '@spotahome/ui-library/base';

import ListingTagModal from './ListingTagModal';

import './ListingChipsContainer.scss';

const MAX_VISIBLE_CHIPS = 8;

const ListingChipsContainer = ({
  chipList = [],
  className = '',
  modalHeaderLabel = null
}) => {
  const { isModalOpen, handleModalOpen, handleModalClose } = useModalHandle();

  const allChips = chipList
    .filter(tag => !tag.hideInExperiment && tag.icon)
    .sort((a, b) => !!b.value - !!a.value || a.order - b.order)
    .map(tag => (
      <Tag
        key={tag.label || tag.name}
        label={tag.name}
        renderLeadingIcon={() => <DSIcon name={tag.icon} />}
        isSpaced
        size="big"
        colorSchema="light"
        labelClassName={classNames({
          'listing-chips-container__tag--clickable': tag.onClick,
          'listing-chips-container__tag--not-included': !tag.value
        })}
        onClick={tag.onClick}
      />
    ));

  return (
    <>
      <ListingTagModal
        isOpen={isModalOpen}
        onRequestClose={handleModalClose}
        headerLabel={modalHeaderLabel}
      >
        <div className="listing-chips-container">{allChips}</div>
      </ListingTagModal>
      <div className={classNames('listing-chips-container', className)}>
        {allChips.slice(0, MAX_VISIBLE_CHIPS)}
      </div>
      {allChips.length > MAX_VISIBLE_CHIPS && (
        <Button
          className="listing-chips-container__show-features-button"
          color="link"
          onClick={handleModalOpen}
          dataTest="showRemainingFeaturesButton"
        >
          {trans('search.listing.show-all-features', {
            numberOfFeatures: allChips.length
          })}
        </Button>
      )}
    </>
  );
};

ListingChipsContainer.propTypes = {
  chipList: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      icon: PropTypes.string,
      description: PropTypes.string,
      descriptionClassName: PropTypes.string,
      order: PropTypes.number,
      hideInExperiment: PropTypes.bool,
      onClick: PropTypes.func
    })
  ),
  className: PropTypes.string,
  modalHeaderLabel: PropTypes.string
};

export default ListingChipsContainer;
